export default __webpack_public_path__ + "static/media/icon-volume-mute.af6fd54d.svg";